import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import './product-offering.component.scss';
import * as $ from 'jquery';
import * as _ from 'lodash';
var ProductOffering = /** @class */ (function (_super) {
    tslib_1.__extends(ProductOffering, _super);
    function ProductOffering(element, analyticsService) {
        return _super.call(this, element) || this;
    }
    ProductOffering.prototype.init = function () {
        var storage = localStorage.getItem('comparison');
        this.endpoint = this.element.getAttribute('data-endpoint');
        this.productKey = this.element.getAttribute('data-productkey');
        this.productContainer = $('.product-card-wrapper');
        this.removeAll = $('.js-remove-all');
        this.producttype = $("div.component.product-offering").attr('data-producttype');
        if (this.producttype) {
            this.producttype = this.producttype.toLowerCase();
        }
        if (!storage) {
            storage = {};
            storage[this.productKey] = [];
            localStorage.setItem('comparison', JSON.stringify(storage));
        }
        else {
            storage = JSON.parse(storage);
            if (!storage[this.productKey]) {
                storage[this.productKey] = [];
                localStorage.setItem('comparison', JSON.stringify(storage));
            }
        }
        if (this.element.getAttribute('data-comparetext')) {
            this.compareText = this.element.getAttribute('data-comparetext');
        }
        this.comparison = storage;
        this.getProducts();
        TooltipsService.initTooltips();
    };
    ProductOffering.prototype.bindEvents = function () {
        var _this = this;
        $(document).on('click', '.js-remove-compare', function (e) {
            var productId = $(e.currentTarget).data('id');
            if (_this.comparison[_this.productKey].find(function (item) { return item == productId; })) {
                var index = _this.comparison[_this.productKey].indexOf(productId);
                if (index >= 0) {
                    _this.comparison[_this.productKey].splice(index, 1);
                    localStorage.setItem('comparison', JSON.stringify(_this.comparison));
                    if (_this.comparison[_this.productKey].length >= 2) {
                        $('.js-compare-button').removeClass('button--disabled');
                    }
                    else {
                        $('.js-compare-button').addClass('button--disabled');
                    }
                    $(".product-offering .form__control--checkbox input").removeAttr('disabled');
                    $(".product-card[data-id='" + productId + "'] .product-card__outer").removeClass("gradient-border");
                    $(".product-offering .form__control--checkbox[data-id='" + productId + "'] input").prop('checked', false);
                    $(".product-offering__compare-chip[data-id='" + productId + "']").addClass('product-offering__compare-chip--hide');
                    setTimeout(function () {
                        $(".product-offering__compare-chip[data-id='" + productId + "']").remove();
                        if (!_this.productComparisonCheck()) {
                            $('.product-offering__compare').removeClass('product-offering__compare--active');
                        }
                    }, 300);
                }
            }
        });
        this.removeAll.click(function (e) {
            e.preventDefault();
            $(".product-card .product-card__outer").removeClass("gradient-border");
            $(".product-offering .form__control--checkbox input").removeAttr('disabled');
            $(".product-offering .form__control--checkbox input").prop('checked', false);
            $(".product-offering__compare-chip").addClass('product-offering__compare-chip--hide');
            setTimeout(function () {
                $(".product-offering__compare-chip").remove();
                _this.comparison[_this.productKey] = [];
                localStorage.setItem('comparison', JSON.stringify(_this.comparison));
                $('.product-offering__compare').removeClass('product-offering__compare--active');
                $('.js-compare-button').removeClass('button--disabled');
            }, 300);
        });
        window.addEventListener('resize', this.debounce(function () {
            _this.normalizeCardHeight();
        }, 50, false));
        // extending functionality for PPB 'southafrica/personal'
        document.addEventListener("DOMContentLoaded", function () {
            if (window.location.pathname.includes("/southafrica/personal")) {
                var urlParams = new URLSearchParams(window.location.search);
                var filterValue_1 = urlParams.get("filter");
                if (filterValue_1) {
                    var dropdownValueText_1 = document.querySelector(".product-filter__dropdown-value-text");
                    var filterItems = document.querySelectorAll(".product-filter__item");
                    filterItems.forEach(function (item) {
                        if (item.getAttribute("data-filter") === filterValue_1) {
                            dropdownValueText_1.textContent = item.textContent;
                        }
                    });
                }
            }
        });
    };
    ProductOffering.prototype.getProducts = function () {
        var _this = this;
        var parseData = jsonData;
        this.filterJson = parseData.filters;
        this.productJson = parseData.products;
        this.comparable = _.some(this.productJson, function (product) {
            return product.comparable;
        });
        if (document.querySelector('.product-filter')) {
            this.renderFilters();
        }
        else if (document.querySelector('.product-filter-dropdown')) {
            this.renderDropdownFilters();
        }
        var docfragment = document.createDocumentFragment();
        var iCount = 1;
        this.productJson.forEach(function (card) {
            docfragment.appendChild(_this.renderProduct(card, iCount));
        });
        this.productContainer[0].appendChild(docfragment);
        this.normalizeCardHeight();
        this.compareCard = $('.js-compare');
        this.compareCard.click(function (e) { return _this.compareClick(e); });
        if (this.comparison) {
            console.log('Comparison Amount', this.comparison[this.productKey].length);
            this.comparison[this.productKey].forEach(function (id) {
                $(".product-card[data-id='" + id + "'] .product-card__outer").addClass("gradient-border");
                $(".product-offering .form__control--checkbox[data-id='" + id + "'] input").prop('checked', 'checked');
            });
            if (this.comparison[this.productKey].length >= 3) {
                $(".product-offering .form__control--checkbox input").prop('disabled', 'disabled');
                this.comparison[this.productKey].forEach(function (id) {
                    $(".product-offering .form__control--checkbox[data-id='" + id + "'] input").removeAttr('disabled');
                });
            }
            if (this.comparison[this.productKey].length > 0) {
                var hasComparedProducts = false;
                if (this.productComparisonCheck()) {
                    $('.product-offering__compare').addClass('product-offering__compare--active');
                    this.comparison[this.productKey].forEach(function (id) {
                        _this.renderComparisonChips(id);
                    });
                }
            }
            if (this.comparison[this.productKey].length >= 2) {
                $('.js-compare-button').removeClass('button--disabled');
            }
            else {
                $('.js-compare-button').addClass('button--disabled');
            }
        }
        this.normalizeCardHeight();
    };
    ProductOffering.prototype.normalizeCardHeight = function () {
        if ($(window).width() < 951) {
            $('.product-card__content').css('min-height', "initial");
            $('.product-card__content > p').css('min-height', "initial");
            $('.product-card__terms').css('min-height', "initial");
        }
        else {
            var highestContent_1 = 0;
            $('.product-card__content').each(function (index, el) {
                var contentHeight = $(el).outerHeight();
                if (highestContent_1 < contentHeight) {
                    highestContent_1 = contentHeight;
                }
            });
            $('.product-card__content').css('min-height', highestContent_1 + 'px');
            var highestParagragh_1 = 0;
            $('.product-card__content > p').each(function (index, el) {
                var paragraphHeight = $(el).height();
                if (highestParagragh_1 < paragraphHeight) {
                    highestParagragh_1 = paragraphHeight;
                }
            });
            $('.product-card__content > p').css('min-height', highestParagragh_1 + 'px');
            var highestTerms_1 = 0;
            $('.product-card__terms').each(function (index, el) {
                var termHeight = $(el).height();
                if (highestTerms_1 < termHeight) {
                    highestTerms_1 = termHeight;
                }
            });
            $('.product-card__terms').css('min-height', highestTerms_1 + 'px');
        }
    };
    ProductOffering.prototype.compareClick = function (e) {
        var _this = this;
        var productId = $(e.currentTarget).parent().data('id');
        if (!this.comparison[this.productKey]) {
            this.comparison[this.productKey].push(productId);
            localStorage.setItem('comparison', JSON.stringify(this.comparison));
            this.renderComparisonChips(productId);
            $('.product-offering__compare').addClass('product-offering__compare--active');
            $('.js-compare-button').addClass('button--disabled');
        }
        else {
            if (this.comparison[this.productKey].find(function (item) { return item == productId; })) {
                var index = this.comparison[this.productKey].indexOf(productId);
                if (index >= 0) {
                    this.comparison[this.productKey].splice(index, 1);
                    localStorage.setItem('comparison', JSON.stringify(this.comparison));
                    $(".product-offering .form__control--checkbox input").removeAttr('disabled');
                    $(".product-offering__compare-chip[data-id='" + productId + "']").remove();
                    $(".product-offering__compare-chip[data-id='" + productId + "']").addClass('product-offering__compare-chip--hide');
                    setTimeout(function () {
                        $(".product-offering__compare-chip[data-id='" + productId + "']").remove();
                        if (!_this.productComparisonCheck()) {
                            $('.product-offering__compare').removeClass('product-offering__compare--active');
                        }
                    }, 300);
                }
            }
            else if (this.comparison[this.productKey].length < 3) {
                this.comparison[this.productKey].push(productId);
                localStorage.setItem('comparison', JSON.stringify(this.comparison));
                this.renderComparisonChips(productId);
                if (this.comparison[this.productKey].length >= 3) {
                    $(".product-offering .form__control--checkbox input").prop('disabled', 'disabled');
                    this.comparison[this.productKey].forEach(function (id) {
                        $(".product-offering .form__control--checkbox[data-id='" + id + "'] input").removeAttr('disabled');
                    });
                }
            }
            if (this.productComparisonCheck()) {
                $('.product-offering__compare').addClass('product-offering__compare--active');
            }
            if (this.comparison[this.productKey].length >= 2) {
                $('.js-compare-button').removeClass('button--disabled');
            }
            else {
                $('.js-compare-button').addClass('button--disabled');
            }
        }
        if ($(".product-card[data-id='" + productId + "'] .product-card__outer").hasClass("gradient-border")) {
            $(".product-card[data-id='" + productId + "'] .product-card__outer").removeClass("gradient-border");
        }
        else {
            $(".product-card[data-id='" + productId + "'] .product-card__outer").addClass("gradient-border");
        }
    };
    ProductOffering.prototype.productComparisonCheck = function () {
        var _this = this;
        //checks to see if the products from JSON match anything in the local storage
        return _.some(this.comparison[this.productKey], function (el) {
            return _.includes(_.map(_this.productJson, function (prod) { return prod.id; }), el);
        });
    };
    ProductOffering.prototype.renderProduct = function (input, orderIndex) {
        var _this = this;
        var productPrices = "";
        var productTags = "";
        var productTerms = "";
        var productButtons = "";
        var termCount = 0;
        input.pricing.forEach(function (price) {
            if (price.terms) {
                termCount++;
                var asterix = '';
                for (var index = 0; index < termCount; index++) {
                    asterix += '*';
                }
                productTerms += '<div><span class="title title--asterisk">' + asterix + '</span><span>' + price.terms + '</span></div>';
            }
            productPrices += _this.renderProductPrice(price, termCount);
        });
        var btnCount = 0;
        input.buttons.forEach(function (btn) {
            productButtons += _this.renderButtons(btn, btnCount, input);
            btnCount++;
        });
        productTerms = '<div class="product-card__terms">' + productTerms + '</div>';
        input.tags.forEach(function (tag) {
            productTags += " " + tag.replace(/ /g, "-");
        });
        var output = "";
        output += '<div class="product-card product-card__image ' + productTags.toLowerCase() + '" data-id="' + input.id + '" style="order: ' + orderIndex + ';">';
        switch (input.title.toLowerCase()) {
            case "student loan": {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">Increase Limit</div>';
                }
                break;
            }
            case "overdraft": {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">Increase Limit</div>';
                }
                break;
            }
            case "revolving loan": {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">Increase Limit</div>';
                }
                break;
            }
            case "mymobiz plus account": {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">Bundle Offering</div>';
                }
                break;
            }
            case "mymobiz account": {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">Pay as you transact</div>';
                }
                break;
            }
            default: {
                if (input.onPromotion) {
                    output += '<div class="product-card__feature-badge feature-badge">' + input.promotionLabel + '</div>';
                }
            }
        }
        if (input.cardImage) {
            output += '<img class="product-card__image--card" src="' + input.cardImage + '">';
        }
        output += '<div class="product-card__outer"><div class="product-card__inner" data-trackingregion="product offering ' + this.producttype + ' > ' + input.title.toLowerCase() + '"><div class="product-card__content"><h4 class="title title--module-sub-title product-card__title">' + input.title + '</h4><div class="title title-gradient title-gradient--product"></div><p>' + input.subTitle + '</p><div class="row">' + productPrices + '</div></div>';
        //card buttons
        output += '<div class="product-card__buttons"><div class="row"><div class="col-12">' + productTerms + '<div class="float-md-right float-sm-left">';
        if (input.comparable) {
            if (this.compareText) {
                output += '<label data-id="' + input.id + '" class="form__control form__control--checkbox">' + this.compareText + '<input type="checkbox" class="js-compare"><div class="form__control-indicator"></div></label>';
            }
            else {
                output += '<label data-id="' + input.id + '" class="form__control form__control--checkbox">Add to compare<input type="checkbox" class="js-compare"><div class="form__control-indicator"></div></label>';
            }
        }
        else {
            output += '<div class="' + (this.comparable ? 'product-card__compare-placeholder' : 'product-card__compare-placeholder -card__compare-placeholder--sml') + '"></div>';
        }
        output += '</div></div>' + productButtons + '</div></div>';
        //end card buttons
        output += '</div>'; //inner close
        output += '</div>'; //outer close
        output += '</div>'; //main close
        return document.createRange().createContextualFragment(output);
    };
    ProductOffering.prototype.renderButtons = function (input, index, product) {
        var output = "";
        // Analytics - included the product in the param lis so we can get the prod name
        var productTitle = product.title ? product.title : "<<product name>>";
        var dataIntent = 'Informational';
        var dataClass = 'button--main';
        if (input.buttonClass) {
            var dataButtonClass = input.buttonClass.toLowerCase();
            if (dataButtonClass === 'eligibility') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'callmeback') {
                dataIntent = 'Query';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'apply') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'applywhitebutton') {
                dataIntent = 'Transactional';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contactus') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contact us') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contact') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'productdetails') {
                dataIntent = 'Informational';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'compare') {
                dataIntent = 'Comparison;';
                dataClass = 'button--white button--border-blue';
            }
            else {
                dataClass = 'button--white button--border-blue';
            }
        }
        if (input.isModal) {
            output += '<div class="' + (index === 0 ? 'product-card__button-wrap' : '') + ' col-xs-6 col-sm-6"><a class="button ' + dataClass + ' js-apply-now-modal-open" href="#" target="" data-modal="apply-now-modal-' + input.modalId + '" data-intent="' + dataIntent + '" data-scope="productOffering" data-id="link_content_product offering" data-text="' + this.producttype + ' | ' + productTitle + ' | ' + input.title + ' button click">' + input.title + '</a></div>';
        }
        else {
            output += '<div class="' + (index === 0 ? 'product-card__button-wrap' : '') + ' col-xs-6 col-sm-6"><a class="button ' + dataClass + '" href="' + input.url + '" target="' + input.target + '" data-intent="' + dataIntent + '" data-scope="productOffering" data-id="link_content_product offering" data-text="' + this.producttype + ' | ' + productTitle + ' | ' + input.title + ' button click">' + input.title + '</a></div>';
            // output += '<div class="' + (index === 0 ? 'product-card__button-wrap' : '') + ' col-xs-6 col-sm-6"><a class="button button--main ' + (index === 0 ? '' : 'button--white button--border-blue') + '" href="' + input.url + '" target="' + input.target + '" data-intent="' + dataIntent + '" data-scope="productOffering" data-id="link_content_product offering" data-text="' + this.producttype + ' | ' + productTitle + ' | ' + input.title + ' button click">' + input.title + '</a></div>';
        }
        return output;
    };
    ProductOffering.prototype.renderProductPrice = function (input, termCount) {
        var modifiers = "";
        var output = "";
        var title = input.title;
        if (title.length > 6) {
            modifiers = 'product-card__price--modifier';
        }
        output += '<div class="product-card__price col-6 col-xs-6 col-sm-6 ' + modifiers + '">';
        if (input.symbol && input.symbol.toLowerCase() == 'r') {
            output += '<span class="title title--initial title--currency">' + input.symbol + '</span>';
        }
        if (input.note) {
            output += '<span class="title title--initial product-card__price__note">' + input.title + '</span>';
        }
        else {
            output += '<span class="title title--initial title--number">' + input.title + '</span>';
        }
        if (input.symbol && input.symbol.toLowerCase() != 'r') {
            output += '<span class="title title--initial title--currency">' + input.symbol + '</span>';
        }
        if (input.tooltip) {
            output += '<span title="' + input.tooltip + '" data-title="' + input.tooltip + '"><i data-component="icon" data-icon="icon-tooltip" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#0089FF" fill-rule="evenodd" d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z"></path></svg></i></span>';
        }
        if (input.terms) {
            var asterix = '';
            for (var index = 0; index < termCount; index++) {
                asterix += '*';
            }
            output += '<span class="title title--initial title--asterisk">' + asterix + '</span>';
        }
        if (input.strike) {
            output += '<div class="title title--initial title--number-strike"><span class="title title--number-striker"></span>';
            if (input.symbol) {
                output += '<span class="title title--initial title--currency-sml">' + input.symbol + '</span>';
            }
            output += '<span class="title title--initial title--number-sml">' + input.strike + '</span></div>';
        }
        output += '<div class="title title--notes">' + input.subTitle + '</div>';
        output += '</div>'; //main close
        return output;
    };
    ProductOffering.prototype.renderComparisonChips = function (id) {
        var item = this.productJson.find(function (item) { return item.id == id; });
        var output = "";
        output += '<span class="product-offering__compare-chip" data-id="' + item.id + '"><span class="title title--notes">' + item.title + '</span><i class="icon js-remove-compare" data-id="' + item.id + '"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g fill="none" fill-rule="evenodd"><circle cx="10" cy="10" r="10" fill="#0089FF"></circle><path fill="#FFF" d="M15 5.604L14.396 5 10 9.396 5.604 5 5 5.604 9.396 10 5 14.396l.604.604L10 10.604 14.396 15l.604-.604L10.604 10 15 5.604"></path></g></svg></i></span>';
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        $('.product-offering__compare-chip-wrapper')[0].appendChild(docfragment);
        $('.product-offering__compare-chip-wrapper')[0].appendChild(docfragment);
    };
    ProductOffering.prototype.renderFilters = function () {
        if (this.filterJson && this.filterJson.length > 0) {
            $('.product-filter').addClass('product-filter--show');
            $('.product-filter').removeClass('product-filter--hide');
            var filterfragment_1 = document.createDocumentFragment();
            this.filterJson.forEach(function (filter) {
                filterfragment_1.appendChild(document.createRange().createContextualFragment('<span class="product-filter__item" data-filter="' + filter + '" data-id="link_tab_tab" data-text="product offering > ' + filter.toLowerCase() + '">' + filter + '</span>'));
            });
            document.querySelector('.product-filter__wrapper').appendChild(filterfragment_1);
        }
        else {
            if (this.filterJson) {
                $('.product-filter').addClass('product-filter--none');
                $('.product-filter').removeClass('product-filter--hide');
                $('.product-filter__placeholder > a').attr('src', this.element.getAttribute('data-filterurl'));
                $('.product-filter__placeholder .link__text').text(this.element.getAttribute('data-filtertext'));
            }
        }
    };
    ProductOffering.prototype.renderDropdownFilters = function () {
        if (this.filterJson && this.filterJson.length > 0) {
            $('.product-filter-dropdown').addClass('product-filter-dropdown--show');
            $('.product-filter-dropdown').removeClass('product-filter-dropdown--hide');
            var filterfragment_2 = document.createDocumentFragment();
            this.filterJson.forEach(function (filter) {
                filterfragment_2.appendChild(document.createRange().createContextualFragment('<span class="product-filter-dropdown__item" data-filter="' + filter + '" data-id="link_tab_tab" data-text="product offering > ' + filter.toLowerCase() + '">' + filter + '</span>'));
            });
            document.querySelector('.product-filter-dropdown__wrapper').appendChild(filterfragment_2);
        }
        else {
            if (this.filterJson) {
                $('.product-filter-dropdown').addClass('product-filter-dropdown--none');
                $('.product-filter-dropdown').removeClass('product-filter-dropdown--hide');
                $('.product-filter-dropdown__placeholder > a').attr('src', this.element.getAttribute('data-filterurl'));
                $('.product-filter-dropdown__placeholder .link__text').text(this.element.getAttribute('data-filtertext'));
            }
        }
    };
    ProductOffering.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    return ProductOffering;
}(Base));
export { ProductOffering };



//////////////////
// WEBPACK FOOTER
// ./components/product-offering/product-offering.component.ts
// module id = 447
// module chunks = 0